import { rankingData } from "@/mocks/homeData";

export default function RankingSection() {
  const changeIcon = (change: string) => {
    if (change === "up") return <i className="ri-arrow-up-line text-emerald-500 text-sm"></i>;
    if (change === "down") return <i className="ri-arrow-down-line text-red-400 text-sm"></i>;
    return <span className="text-xs text-accent-500 font-semibold whitespace-nowrap">NEW</span>;
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <div className="lg:w-1/3">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2 font-heading">🏆 吃瓜热度排行</h2>
            <p className="text-sm text-foreground-600 mb-6">
              综合阅读量、评论数和搜索热度实时计算，每小时自动更新，让你掌握当下最热门的51吃瓜资讯。
            </p>
            <a
              href="#cards"
              onClick={(e) => { e.preventDefault(); const el = document.querySelector("#cards"); if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: "smooth" }); }}
              className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer transition-colors whitespace-nowrap"
            >
              查看全部爆料 <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div className="lg:w-2/3 space-y-2">
            {rankingData.map((item) => (
              <div
                key={item.rank}
                className={`flex items-center gap-3 md:gap-4 bg-background-50 border border-background-200/70 rounded-xl px-4 py-3 md:px-5 md:py-4 cursor-pointer transition-all hover:border-primary-200/50 ${
                  item.rank <= 3 ? "hover:shadow-md" : ""
                }`}
              >
                <span className={`w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold flex-shrink-0 ${
                  item.rank === 1
                    ? "bg-accent-500 text-background-50"
                    : item.rank === 2
                    ? "bg-amber-400 text-background-50"
                    : item.rank === 3
                    ? "bg-amber-300 text-foreground-950"
                    : "bg-background-100 text-foreground-600"
                }`}>
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate font-heading">{item.title}</h3>
                  <span className="text-xs text-foreground-500">{item.heat}</span>
                </div>
                <span className="flex-shrink-0">{changeIcon(item.change)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}